import type {
  ProfileVerifications,
  Verifiable,
  Verified,
} from 'src/components/Profile/Verifications/types';
import * as Schema from 'src/types/graphql';
import { CredentialExpiryStatus } from 'src/types/graphql';

export const _id = '12345678';

export const confirmedRoles = [
  {
    id: 'acb3ec9f-b227-5165-94b6-aa66d0721f67',
    title: {
      text: 'Archivist',
      ontologyId: 'http://ontology-id/archivist',
    },
    company: {
      text: 'Scentre Group Ltd',
      ontologyId: 'http://ontology-id/scentre-group-ltd',
    },
    from: {
      year: 1970,
      month: 7,
    },
    achievements:
      'Maintain personal ability in, and appropriate use of, all relevant ICT (Information & Communications Technology) and other systems within the import/export function.',
    to: {
      year: 1994,
      month: 12,
    },
    function: null,
    industry: null,
  },
  {
    id: 'acb3ec9f-b227-5165-94b6-aa66d0721f68',
    title: {
      text: 'Book reader',
      ontologyId: 'http://ontology-id/book-reader',
    },
    company: {
      text: 'Library',
      ontologyId: 'http://ontology-id/library',
    },
    from: {
      year: 1995,
      month: 7,
    },
    achievements: null,
    to: {
      year: 2000,
      month: 12,
    },
    function: null,
    industry: null,
  },
];

export const confirmedQualifications = [
  {
    id: '143aabbc-abcd-55ea-b6bb-4b164a0b150a',
    institute: {
      text: 'Monash',
      ontologyId: 'http://ontology-id-1/',
    },
    name: {
      text: 'Bachelor of Lego',
      ontologyId: 'http://ontology-id-2/',
    },
    completed: false,
    completionDate: {
      month: 3,
      year: 2018,
      __typename: 'MonthYear',
    },
    credential: null,
    formattedCompletion: 'Expected finish Mar 2018',
    highlights:
      'Investigate, plan and implement strategically effective and relevant transport methods, which meet optimally the needs of the organization and its suppliers and customers.',
    isVerified: false,
  },
  {
    id: 'a793af6f-e571-5c6e-a079-0fe1b06e5c17',
    institute: {
      text: 'Monash',
      ontologyId: 'http://ontology-id-3/',
    },
    name: {
      text: 'Certficate IV in Yoyo',
      ontologyId: 'http://ontology-id-4/',
    },
    completed: false,
    completionDate: {
      month: 2,
      year: 2015,
      __typename: 'MonthYear',
    },
    formattedCompletion: 'Expected finish Feb 2015',
    highlights:
      'Maintain and update continuously, by local knowledge and by local means, a log of the availability of staff likely to receive inbound calls. Maintain and update continuously, by local knowledge and by local means, a log of the availability of staff likely to receive inbound calls. Maintain and update continuously, by local knowledge and by local means, a log of the availability of staff likely to receive inbound calls. Maintain and update continuously, by local knowledge and by local means, a log of the availability of staff likely to receive inbound calls. Maintain and update continuously, by local knowledge and by local means, a log of the availability of staff likely to receive inbound calls. Maintain and update continuously, by local knowledge and by local means, a log of the availability of staff likely to receive inbound calls.',
    credential: null,
    isVerified: false,
  },
  {
    id: 'f625f442-6904-51a8-aa03-e7df4fae61a5',
    institute: {
      text: 'RMIT',
      ontologyId: 'http://ontology-id-5/',
    },
    name: {
      text: 'Bachelor of Yoyo',
      ontologyId: 'http://ontology-id-6/',
    },
    completed: true,
    completionDate: {
      year: 2010,
      __typename: 'Year',
    },
    formattedCompletion: 'Finished 2010',
    highlights:
      'Liaise and co-operate with quality management and standards bodies (e.g., BSI, Government Departments, HSE, etc) Manage staff according to company standards (appraisals, discipline, training, development, etc).',
    credential: null,
    status: null,
    verificationUrl:
      'https://seekpass.co/credentials/education-qualifications?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=education-qualifications',
    isVerified: false,
  },
  {
    id: 'f625f442-6904-51a8-aa03-e7df4fae61a1',
    institute: {
      ontologyId: null,
      text: 'Monash College',
    },
    name: {
      ontologyId: null,
      text: 'Master of Laws',
    },
    completed: true,
    completionDate: {
      year: 2010,
      __typename: 'Year',
    },
    formattedCompletion: 'Finished 2010',
    highlights:
      'Liaise and co-operate with quality management and standards bodies (e.g., BSI, Government Departments, HSE, etc) Manage staff according to company standards (appraisals, discipline, training, development, etc).',
    status: 'New',
    credential: {
      credentialInfo: [
        {
          name: 'Education Provider',
          values: ['Monash College'],
        },
        {
          name: 'Finished',
          values: ['2000'],
        },
        {
          name: 'Full name',
          values: ['John Doe'],
        },
        {
          name: 'Verified on',
          values: ['4 May 2021'],
        },
      ],
      deleteVerificationUrl:
        'https://seekpass.co/data-sharing?utm_source=seek&utm_medium=referral&utm_campaign=profile-delete&utm_content=education-qualifications',
      manageVerificationUrl:
        'https://seekpass.co/career-passport/education-qualifications?utm_source=seek&utm_medium=referral&utm_campaign=profile-manage&utm_content=education-qualifications',
    },
    isVerified: true,
  },
];

export const licences = [
  {
    id: '617f57f5-5b4f-4f35-adec-64240eae3ac5',
    name: {
      text: 'Drivers licence',
      ontologyId: 'http://ontology-id-1/',
    },
    issuingOrganisation: 'Vic roads',
    noExpiryDate: false,
    issueDate: {
      month: 1,
      year: 2015,
      __typename: 'MonthYear',
    },
    expiryDate: {
      month: 3,
      year: 2030,
      __typename: 'MonthYear',
    },
    status: null,
    description: 'I like to drive',
    formattedDate: 'Jan 2015 - Mar 2030',
    isVerified: false,
  },
  {
    id: 'e255916c-f7f1-47f6-a6c3-32e005febd2',
    name: {
      text: 'Drivers licence',
      ontologyId: 'http://ontology-id-2/',
    },
    issuingOrganisation: 'Vicroads',
    noExpiryDate: true,
    issueDate: {
      month: 1,
      year: 2015,
    },
    expiryDate: {
      month: 1,
      year: 2030,
    },
    status: 'New',
    description: null,
    formattedDate: undefined,
    credential: {
      expiryStatus: null,
      verification: { result: 'Verified Valid Drivers Licence' },
      credentialInfo: [{ name: 'Full name', values: ['John Doe'] }],
      manageVerificationUrl:
        'https://seekpass.co/drivers-licence?utm_source=seek&utm_medium=referral&utm_campaign=profile-manage&utm_content=right-to-work',
      deleteVerificationUrl:
        'https://seekpass.co/data-sharing?utm_source=seek&utm_medium=referral&utm_campaign=profile-delete&utm_content=drivers-licence',
    },
    isVerified: true,
  },
  {
    id: 'e255916c-f7f1-47f6-a6c3-32e005febd2c',
    name: {
      text: 'Drivers licence',
      ontologyId: 'http://ontology-id-2/',
    },
    issuingOrganisation: 'Vicroads',
    noExpiryDate: true,
    issueDate: {
      month: 1,
      year: 2015,
    },
    expiryDate: {
      month: 1,
      year: 2025,
    },
    status: 'New',
    description: null,
    formattedDate: 'Jan 2015 - Jan 2025',
    credential: {
      expiryStatus: CredentialExpiryStatus.ExpiringSoon,
      verification: { result: 'Verified Valid Drivers Licence' },
      credentialInfo: [{ name: 'Full name', values: ['John Doe'] }],
      manageVerificationUrl:
        'https://seekpass.co/drivers-licence?utm_source=seek&utm_medium=referral&utm_campaign=profile-manage&utm_content=right-to-work',
      deleteVerificationUrl:
        'https://seekpass.co/data-sharing?utm_source=seek&utm_medium=referral&utm_campaign=profile-delete&utm_content=drivers-licence',
    },
    isVerified: true,
  },
  {
    id: '94a3ee70-04db-4e35-a2cc-b1a76f4a396b',
    name: {
      text: 'Project management',
      ontologyId: 'http://ontology-id-3/',
    },
    issuingOrganisation: 'PMP',
    noExpiryDate: false,
    issueDate: null,
    expiryDate: null,
    status: 'New',
    description: null,
    formattedDate: null,
    credential: null,
    isVerified: false,
  },
];

export const verifiedLicencesWithExpiryStatus = [
  {
    id: 'e255916c-f7f1-47f6-a6c3-32e005febd2c',
    name: {
      text: 'Drivers licence',
      ontologyId: 'http://ontology-id-2/',
    },
    issuingOrganisation: 'Vicroads',
    noExpiryDate: true,
    issueDate: {
      month: 1,
      year: 2015,
    },
    expiryDate: {
      month: 1,
      year: 2025,
    },
    status: 'New',
    description: null,
    formattedDate: 'Jan 2015 - Jan 2025',
    credential: {
      expiryStatus: CredentialExpiryStatus.ExpiringSoon,
      verification: { result: 'Verified Valid Drivers Licence' },
      credentialInfo: [{ name: 'Full name', values: ['John Doe'] }],
      manageVerificationUrl:
        'https://seekpass.co/drivers-licence?utm_source=seek&utm_medium=referral&utm_campaign=profile-manage&utm_content=right-to-work',
      deleteVerificationUrl:
        'https://seekpass.co/data-sharing?utm_source=seek&utm_medium=referral&utm_campaign=profile-delete&utm_content=drivers-licence',
    },
    isVerified: true,
  },
  {
    id: '94a3ee70-04db-4e35-a2cc-b1a76f4a396b',
    name: {
      text: 'Project management',
      ontologyId: 'http://ontology-id-3/',
    },
    issuingOrganisation: 'PMP',
    noExpiryDate: false,
    issueDate: null,
    expiryDate: null,
    status: 'New',
    description: null,
    formattedDate: 'Jan 2015 - Jan 2025',
    credential: {
      expiryStatus: CredentialExpiryStatus.Expired,
      verification: { result: 'Verified Valid Drivers Licence' },
      credentialInfo: [{ name: 'Full name', values: ['John Doe'] }],
      manageVerificationUrl:
        'https://seekpass.co/drivers-licence?utm_source=seek&utm_medium=referral&utm_campaign=profile-manage&utm_content=right-to-work',
      deleteVerificationUrl:
        'https://seekpass.co/data-sharing?utm_source=seek&utm_medium=referral&utm_campaign=profile-delete&utm_content=drivers-licence',
    },
    isVerified: true,
  },
];

export const profileVisibility = {
  level: 'Standard',
};

export const salaryPreferences: Schema.SalaryPreference2[] = [
  {
    id: '332369be-af46-5768-b039-52e5e57b7959',
    country: {
      countryCode: 'AU',
      name: 'Australia',
    },
    currencyCode: 'AUD',
    amount: null,
    salaryType: Schema.SalaryType2.Hourly,
    description: null,
  },
  {
    id: '332369be-af46-5768-b039-52e5e57b795a',
    country: {
      countryCode: 'NZ',
      name: 'New Zealand',
    },
    currencyCode: 'NZD',
    amount: 30000,
    salaryType: Schema.SalaryType2.Annual,
    description: 'NZD 30,000 Annual',
  },
  {
    id: '332369be-af46-5768-b039-52e5e57b795b',
    country: {
      countryCode: 'GB',
      name: 'United Kingdom',
    },
    currencyCode: 'GBP',
    amount: 15,
    salaryType: Schema.SalaryType2.Hourly,
    description: 'GBP 15 Hourly',
  },
  {
    id: '332369be-b244-5768-b039-52e5e57b7959',
    country: {
      countryCode: 'ID',
      name: 'Indonesia',
    },
    currencyCode: 'IDR',
    amount: null,
    salaryType: Schema.SalaryType2.Monthly,
    description: null,
  },
];

export const rightsToWork = [
  {
    id: '332369be-af46-5768-b039-52e5e57b7959',
    country: {
      countryCode: 'AU',
      name: 'Australia',
      __typename: 'CountryInformation',
    },
    type2: null,
    credential: null,
    isDeprecated: false,
    verificationUrl: '',
    __typename: 'RightToWork',
  },
  {
    id: '332369be-af46-5768-b039-52e5e57b795a',
    country: {
      countryCode: 'NZ',
      name: 'New Zealand',
      __typename: 'CountryInformation',
    },
    type2: {
      id: 'http://graph.seek.com/RighttoWork/11e03467-19f4-48f2-8f51-6f13ef9c7c11',
      formattedDescription: 'New Zealand citizen',
      __typename: 'RightToWorkType2',
    },
    credential: null,
    isDeprecated: false,
    verificationUrl: '',
    __typename: 'RightToWork',
  },
  {
    id: '332369be-af46-5768-b039-52e5e57b795b',
    country: {
      countryCode: 'GB',
      name: 'United Kingdom',
      __typename: 'CountryInformation',
    },
    type2: {
      id: 'http://graph.seek.com/RighttoWork/732a2b36-3250-4366-aefa-43281c96f1c1',
      formattedDescription:
        "No, I don't have the right to work in the United Kingdom",
      __typename: 'RightToWorkType2',
    },
    credential: null,
    isDeprecated: false,
    verificationUrl: '',
    __typename: 'RightToWork',
  },
];

export const allRightsToWork = rightsToWork.concat([
  {
    id: '332369be-af46-5768-b039-52e5e57b795c',
    country: {
      countryCode: 'US',
      name: 'United States',
      __typename: 'CountryInformation',
    },
    type2: {
      id: 'http://graph.seek.com/RighttoWork/11e03467-19f4-48f2-8f51-6f13ef9c7c12',
      formattedDescription: 'US citizen',
      __typename: 'RightToWorkType2',
    },
    credential: null,
    isDeprecated: false,
    verificationUrl: '',
    __typename: 'RightToWork',
  },
  {
    id: '332369be-af46-5768-b039-52e5e57b795d',
    country: {
      countryCode: 'DE',
      name: 'Germany',
      __typename: 'CountryInformation',
    },
    type2: null,
    credential: null,
    isDeprecated: false,
    verificationUrl: '',
    __typename: 'RightToWork',
  },
]);

export const deprecatedRightsToWork = [
  {
    id: '332369be-af46-5768-b039-52e5e57b7959',
    country: {
      countryCode: 'AU',
      name: 'Australia',
      __typename: 'CountryInformation',
    },
    type2: null,
    credential: null,
    isDeprecated: true,
    verificationUrl: '',
    __typename: 'RightToWork',
  },
  {
    id: '332369be-af46-5768-b039-52e5e57b795a',
    country: {
      countryCode: 'NZ',
      name: 'New Zealand',
      __typename: 'CountryInformation',
    },
    type2: {
      id: 'http://graph.seek.com/RighttoWork/11e03467-19f4-48f2-8f51-6f13ef9c7c11',
      formattedDescription: 'New Zealand citizen',
      __typename: 'RightToWorkType2',
    },
    credential: null,
    isDeprecated: false,
    verificationUrl: '',
    __typename: 'RightToWork',
  },
  {
    id: '332369be-af46-5768-b039-52e5e57b795b',
    country: {
      countryCode: 'GB',
      name: 'United Kingdom',
      __typename: 'CountryInformation',
    },
    type2: {
      id: 'http://graph.seek.com/RighttoWork/732a2b36-3250-4366-aefa-43281c96f1c1',
      formattedDescription:
        "No, I don't have the right to work in the United Kingdom",
      __typename: 'RightToWorkType2',
    },
    credential: null,
    isDeprecated: false,
    verificationUrl: '',
    __typename: 'RightToWork',
  },
];

const rightToWorkVerified = JSON.parse(JSON.stringify(rightsToWork));

rightToWorkVerified[0].credential = {
  verification: {
    result: 'Permanent unrestricted work rights in Australia',
  },
  expiryFormatted: 'Valid until 1/Jan/2025',
  status: null,
  manageVerificationUrl:
    'https://seekpass.co/right-to-work?utm_source=seek&utm_medium=referral&utm_campaign=profile-manage&utm_content=right-to-work',
};
rightToWorkVerified[0].type2 = {
  id: 'http://graph.seek.com/RighttoWork/04c901da-2d54-4e74-808e-385fbf18ef9f',
  formattedDescription: 'Australian citizen',
  __typename: 'RightToWorkType2',
};
export { rightToWorkVerified };

export const unconfirmedRoles = [
  {
    id: 'acb3ec9f-b227-5165-94b6-aa66d0721f69',
    title: {
      text: 'Anthropologist',
    },
    company: {
      text: 'Computershare Limited',
    },
    from: {
      year: 2012,
      month: 7,
    },
    achievements: null,
    to: {
      year: 2013,
      month: 12,
    },
    function: null,
    industry: null,
  },
];

export const unconfirmedQualifications = [
  {
    id: '143aabbc-abcd-55ea-b6bb-4b164a0b15bc',
    institute: {
      text: 'Monash',
      ontologyId: 'http://ontology-id-1/',
    },
    name: {
      text: 'Bachelor of Idling',
      ontologyId: 'http://ontology-id-2/',
    },
    completed: false,
    completionDate: {
      month: 3,
      year: 2020,
      __typename: 'MonthYear',
    },
    formattedCompletion: 'Finished 2020',
    highlights: 'Managed to idle and pass all 4 years :)',
    credential: null,
  },
];

export const parsedRole = {
  __typename: 'Role',
  id: 'acb3ec9f-b227-5165-94b6-aa66d0721f70',
  title: {
    text: 'Architect',
  },
  company: {
    text: 'Really good design co',
  },
  from: {
    year: 2010,
    month: 7,
  },
  achievements: null,
  to: {
    year: 2020,
    month: 12,
  },
};

export const parsedQualification = {
  __typename: 'Qualification',
  id: '143aabbc-abcd-55ea-b6bb-4b164a0b15bd',
  institute: {
    text: 'Universal university',
    ontologyId: 'http://ontology-id-1/',
  },
  name: {
    text: 'Bachelor of parsing',
    ontologyId: 'http://ontology-id-2/',
  },
  completed: false,
  completionDate: {
    month: 3,
    year: 2014,
    __typename: 'MonthYear',
  },
  formattedCompletion: 'Finished 2020',
  highlights: 'Real good at parsing now',
  credential: null,
};

export const personalDetails = {
  firstName: 'Wayne',
  lastName: 'Reese',
  phoneNumber: '0411 222 333',
  countryCallingCode: { id: '159' },
  defaultCountryCallingCode: { id: '1' },
};

export const personalDetailsNoCountryCallingCode = {
  firstName: 'Wayne',
  lastName: 'Reese',
  phoneNumber: '0411 222 333',
  countryCallingCode: null,
  defaultCountryCallingCode: { id: '1' },
};

export const personalDetailsNoPhoneNumber = {
  firstName: 'Wayne',
  lastName: 'Reese',
  phoneNumber: null,
  countryCallingCode: null,
  defaultCountryCallingCode: { id: '1' },
};

export const emptyPersonalDetails = {
  firstName: null,
  lastName: null,
  phoneNumber: null,
  countryCallingCode: null,
  defaultCountryCallingCode: {
    id: '1',
  },
};

export const currentLocation2 = {
  id: 18578,
  description: 'Melbourne VIC 3000',
  shortDescription: 'Melbourne, Victoria',
  countryCode: 'AU',
  kind: 'Suburb',
  isDeprecated: false,
};

export const deprecatedHomeLocation = {
  id: 1001217,
  description: 'Seoul',
  shortDescription: 'Seoul',
  countryCode: 'SK',
  kind: 'State',
  isDeprecated: true,
};

export const updatedCurrentLocation2 = {
  id: 1234,
  description: 'Cremorne VIC 3121',
  shortDescription: 'Cremorne, Victoria',
  countryCode: 'AU',
  kind: 'Suburb',
  isDeprecated: false,
};

export const personalStatement = {
  personalStatement: 'This is my personal summary',
};

export const workTypes = [
  {
    id: 1,
  },
  {
    id: 2,
  },
  {
    id: 3,
  },
];

export const availability = {
  id: 2,
  description: '2 weeks',
};

export const preferredClassification = {
  id: 6281,
  subClassification: {
    id: 6284,
  },
};

export const preferredLocations2: Schema.Location2[] = [
  {
    countryCode: 'AU',
    description: 'All Melbourne VIC',
    id: 1002,
    shortDescription: 'Melbourne, Victoria',
    kind: 'SEEKLocation',
    isDeprecated: false,
  },
  {
    countryCode: 'AU',
    description: 'Eastern Suburbs Melbourne VIC',
    id: 5071,
    shortDescription: 'Eastern Suburbs, Victoria',
    kind: 'SEEKArea',
    isDeprecated: false,
  },
  {
    countryCode: 'HK',
    description: 'Kwun Tong Kwun Tong District HK',
    id: 1000132,
    shortDescription: 'Kwun Tong Kwun Tong District HK',
    kind: 'Suburb',
    isDeprecated: false,
  },
  {
    countryCode: 'ID',
    description: 'Klaten Central Java ID',
    id: 2030806,
    shortDescription: 'Klaten Central Java ID',
    kind: 'SEEKLocation',
    isDeprecated: false,
  },
  {
    countryCode: 'MY',
    description: 'Johor MY',
    id: 1000178,
    shortDescription: 'Johor MY',
    kind: 'State',
    isDeprecated: false,
  },
  {
    countryCode: 'NZ',
    description: 'Auckland Central Auckland NZ',
    id: 5118,
    shortDescription: 'Auckland Central, Auckland',
    kind: 'SEEKArea',
    isDeprecated: false,
  },
  {
    countryCode: 'PH',
    description: 'Cagayan Valley PH',
    id: 2060400,
    shortDescription: 'Cagayan Valley PH',
    kind: 'Region',
    isDeprecated: false,
  },
  {
    countryCode: 'SG',
    description: 'Ang Mo Kio North-East Region SG',
    id: 2701201,
    shortDescription: 'Ang Mo Kio North-East Region SG',
    kind: 'SEEKArea',
    isDeprecated: false,
  },
  {
    countryCode: 'TH',
    description: 'Amnat Charoen TH',
    id: 2080600,
    shortDescription: 'Amnat Charoen TH',
    kind: 'State',
    isDeprecated: false,
  },
  {
    countryCode: 'IE',
    description: 'Ireland',
    id: 1025,
    shortDescription: 'Ireland',
    kind: 'Country',
    isDeprecated: false,
  },
  {
    id: 5139,
    description: 'USA & Canada',
    shortDescription: 'USA & Canada',
    countryCode: '',
    kind: '',
    isDeprecated: false,
  },
];

export const preferredDeprecatedLocations2: Schema.Location2[] = [
  {
    countryCode: 'IN',
    description: 'Amritsar',
    id: 2042601,
    shortDescription: 'India',
    kind: 'Suburb',
    isDeprecated: true,
  },
  {
    countryCode: 'BH',
    description: 'Bangka',
    id: 2032801,
    shortDescription: 'Bangka',
    kind: 'OverlaySEEK',
    isDeprecated: true,
  },
];

export const errorResumeId = '30910bcb-6861-4e81-9e66-dcee2d4d508c';

export const skills = [
  {
    keyword: {
      text: 'Skill1',
    },
  },
  {
    keyword: {
      text: 'Skill2',
    },
  },
  {
    keyword: {
      text: 'Skill3',
    },
  },
  {
    keyword: {
      text: 'Skill4',
    },
  },
  {
    keyword: {
      text: 'Skill5',
    },
  },
];

export const oneOfEachResumeStatus: Schema.Resume[] = [
  {
    id: '4cb38e1d-3170-55a0-b7bb-4033b7e75102',
    createdDateRelative: '',
    createdDateUtc: '1978-01-20T22:53:54.103Z',
    fileMetadata: {
      name: 'Henry_Perez_cv-2.pdf',
      size: '324k',
      virusScanStatus: Schema.VirusScanStatus.Ok,
      uri: '/v2/blobstore/resumes/abcd',
      status: Schema.FileMetadataStatus.Ok,
      sensitiveDataInfo: null,
    },
    isDefault: true,
    origin: { type: Schema.ResumeOriginType.Uploaded },
  },
  {
    id: 'f425a9ec-452e-5ab3-9fd5-3b9a2ffd18c5',
    createdDateRelative: '',
    createdDateUtc: '2023-06-01T22:53:54.103Z',
    fileMetadata: {
      name: 'Henry_Perez_cv-7.pdf',
      size: '1815k',
      virusScanStatus: Schema.VirusScanStatus.HasVirus,
      uri: '/v2/blobstore/resumes/abcd',
      status: Schema.FileMetadataStatus.HasVirus,
      sensitiveDataInfo: null,
    },
    isDefault: false,
    origin: { type: Schema.ResumeOriginType.Uploaded },
  },
  {
    id: '34943b97-25d2-4954-b2e6-2c6ba2c7c887',
    createdDateRelative: '',
    createdDateUtc: '2021-01-20T22:53:54.103Z',
    fileMetadata: {
      name: 'Henry_Perez_cv-8.pdf',
      size: '324k',
      virusScanStatus: Schema.VirusScanStatus.Ok,
      uri: '/v2/blobstore/resumes/abcd',
      status: Schema.FileMetadataStatus.Ok,
      sensitiveDataInfo: null,
    },
    isDefault: false,
    origin: { type: Schema.ResumeOriginType.Uploaded },
  },
  {
    id: '30910bcb-6861-4e81-9e66-dcee2d4d508c',
    createdDateRelative: '',
    createdDateUtc: '1991-12-18T04:53:48.144Z',
    fileMetadata: {
      name: 'Henry_Perez_cv-3.pdf',
      size: '443k',
      virusScanStatus: Schema.VirusScanStatus.Ok,
      uri: '/v2/blobstore/resumes/abcd',
      status: Schema.FileMetadataStatus.Ok,
      sensitiveDataInfo: null,
    },
    isDefault: false,
    origin: { type: Schema.ResumeOriginType.Uploaded },
  },
  {
    id: 'a5ce9063-bb35-5194-a40b-cc55b83c8c7e',
    createdDateRelative: '',
    createdDateUtc: '1974-04-26T07:06:36.726Z',
    fileMetadata: {
      name: 'Henry_Perez-cv-1.pdf',
      size: '1788k',
      virusScanStatus: Schema.VirusScanStatus.Pending,
      uri: '/v2/blobstore/resumes/abcd',
      status: Schema.FileMetadataStatus.Pending,
      sensitiveDataInfo: null,
    },
    isDefault: false,
    origin: { type: Schema.ResumeOriginType.Uploaded },
  },
];

export const noDefaultResume: Schema.Resume[] = [
  {
    id: '34943b97-25d2-4954-b2e6-2c6ba2c7c887',
    createdDateRelative: '',
    createdDateUtc: '2023-08-01T22:53:54.103Z',
    fileMetadata: {
      name: 'Henry_Perez_cv-2.pdf',
      size: '1815k',
      virusScanStatus: Schema.VirusScanStatus.Ok,
      uri: '/v2/blobstore/resumes/abcd',
      status: Schema.FileMetadataStatus.Ok,
      sensitiveDataInfo: null,
    },
    isDefault: false,
    origin: { type: Schema.ResumeOriginType.Uploaded },
  },
  {
    id: '33f7b2cc-d402-481e-8465-e33b888938cb',
    createdDateRelative: '',
    createdDateUtc: '2021-01-20T22:53:54.103Z',
    fileMetadata: {
      name: 'Henry_Perez_cv-1.pdf',
      size: '324k',
      virusScanStatus: Schema.VirusScanStatus.Ok,
      uri: '/v2/blobstore/resumes/abcd',
      status: Schema.FileMetadataStatus.Ok,
      sensitiveDataInfo: null,
    },
    isDefault: false,
    origin: { type: Schema.ResumeOriginType.Uploaded },
  },
];

export const withSPIResume: Schema.Resume[] = [
  {
    id: '34943b97-25d2-4954-b2e6-2c6ba2c7c8fc',
    createdDateRelative: '',
    createdDateUtc: '2023-07-01T22:53:54.103Z',
    fileMetadata: {
      name: 'Henry_Perez_cv-3.pdf',
      size: '1820k',
      virusScanStatus: Schema.VirusScanStatus.HasVirus,
      uri: '/v2/blobstore/resumes/abcd',
      status: Schema.FileMetadataStatus.Ok,
      sensitiveDataInfo: null,
    },
    isDefault: false,
    origin: { type: Schema.ResumeOriginType.Uploaded },
  },
  {
    id: '34943b97-25d2-4954-b2e6-2c6ba2c7c887',
    createdDateRelative: '',
    createdDateUtc: '2023-08-01T22:53:54.103Z',
    fileMetadata: {
      name: 'Henry_Perez_cv-2.pdf',
      size: '1815k',
      virusScanStatus: Schema.VirusScanStatus.Ok,
      uri: '/v2/blobstore/resumes/abcd',
      status: Schema.FileMetadataStatus.Ok,
      sensitiveDataInfo: null,
    },
    isDefault: false,
    origin: { type: Schema.ResumeOriginType.Uploaded },
  },
  {
    id: '33f7b2cc-d402-481e-8465-e33b888938cb',
    createdDateRelative: '',
    createdDateUtc: '2021-01-20T22:53:54.103Z',
    fileMetadata: {
      name: 'Henry_Perez_cv-1.pdf',
      size: '324k',
      virusScanStatus: Schema.VirusScanStatus.Ok,
      uri: '/v2/blobstore/resumes/abcd',
      status: Schema.FileMetadataStatus.Ok,
      sensitiveDataInfo: {
        isDetected: true,
      },
    },
    isDefault: true,
    origin: { type: Schema.ResumeOriginType.Uploaded },
  },
];

export const tenResumes = oneOfEachResumeStatus.concat([
  {
    id: '0e91563e-6a1d-5e9d-958e-dca0c7313192',
    createdDateRelative: 'Added more than 1 year ago',
    createdDateUtc: '2000-01-01T12:01:01.0000001+11:00',
    fileMetadata: {
      name: 'David-Burgess_resume-5.pdf',
      size: '297KB',
      virusScanStatus: Schema.VirusScanStatus.Pending,
      uri: '/v2/blobstore/resumes/abcd',
      status: Schema.FileMetadataStatus.Pending,
      sensitiveDataInfo: null,
    },
    isDefault: false,
    origin: { type: Schema.ResumeOriginType.Uploaded },
  },
  {
    id: '0e91563e-6a1d-5e9d-958e-dca0c7313193',
    createdDateRelative: 'Added more than 1 year ago',
    createdDateUtc: '2000-01-01T12:01:01.0000001+11:00',
    fileMetadata: {
      name: 'David-Burgess_resume-5.pdf',
      size: '297KB',
      virusScanStatus: Schema.VirusScanStatus.Pending,
      uri: '/v2/blobstore/resumes/abcd',
      status: Schema.FileMetadataStatus.Pending,
      sensitiveDataInfo: null,
    },
    isDefault: false,
    origin: { type: Schema.ResumeOriginType.Uploaded },
  },
  {
    id: '0e91563e-6a1d-5e9d-958e-dca0c7313194',
    createdDateRelative: 'Added more than 1 year ago',
    createdDateUtc: '2000-01-01T12:01:01.0000001+11:00',
    fileMetadata: {
      name: 'David-Burgess_resume-5.pdf',
      size: '297KB',
      virusScanStatus: Schema.VirusScanStatus.Pending,
      uri: '/v2/blobstore/resumes/abcd',
      status: Schema.FileMetadataStatus.Pending,
      sensitiveDataInfo: null,
    },
    isDefault: false,
    origin: { type: Schema.ResumeOriginType.Uploaded },
  },
  {
    id: '0e91563e-6a1d-5e9d-958e-dca0c7313195',
    createdDateRelative: 'Added more than 1 year ago',
    createdDateUtc: '2000-01-01T12:01:01.0000001+11:00',
    fileMetadata: {
      name: 'David-Burgess_resume-5.pdf',
      size: '297KB',
      virusScanStatus: Schema.VirusScanStatus.Pending,
      uri: '/v2/blobstore/resumes/abcd',
      status: Schema.FileMetadataStatus.Pending,
      sensitiveDataInfo: null,
    },
    isDefault: false,
    origin: { type: Schema.ResumeOriginType.Uploaded },
  },
  {
    id: '0e91563e-6a1d-5e9d-958e-dca0c7313196',
    createdDateRelative: 'Added more than 1 year ago',
    createdDateUtc: '2000-01-01T12:01:01.0000001+11:00',
    fileMetadata: {
      name: 'David-Burgess_resume-5.pdf',
      size: '297KB',
      virusScanStatus: Schema.VirusScanStatus.Pending,
      uri: '/v2/blobstore/resumes/abcd',
      status: Schema.FileMetadataStatus.Pending,
      sensitiveDataInfo: null,
    },
    isDefault: false,
    origin: { type: Schema.ResumeOriginType.Uploaded },
  },
]);

export const uploadedOKResume: Schema.Resume = {
  id: '0e91563e-6a1d-5e9d-958e-dca0c7313191',
  createdDateRelative: 'Added more than 1 year ago',
  createdDateUtc: '2000-01-01T12:01:01.0000001+11:00',
  fileMetadata: {
    name: 'David-Burgess_resume-5.pdf',
    size: '297KB',
    virusScanStatus: Schema.VirusScanStatus.Ok,
    uri: '/v2/blobstore/resumes/abcd',
    status: Schema.FileMetadataStatus.Ok,
    sensitiveDataInfo: null,
  },
  origin: { type: Schema.ResumeOriginType.Uploaded },
  isDefault: false,
};

export const languageProficiencies = [
  {
    id: 'ad325316-bb60-4b27-9f33-050c97e0ce5d',
    name: {
      text: 'English',
      ontologyId:
        'https://graph.cloud.seek.com/Spec-Req/4589e2d7-b21e-493e-8f4b-53c912b53b11',
    },
  },
  {
    id: '9f678679-0d44-486f-9fa5-47d3e8bfbcdb',
    name: {
      text: 'French',
      ontologyId:
        'https://graph.cloud.seek.com/Spec-Req/f3daa861-e94e-477c-a4ab-abc97c6bc69c',
    },
  },
];

const identityNotVerified = null;

const identityNameMatch = {
  name: 'Fred Smith',
  isMatchingProfileName: true,
};

const identityNameMismatch = {
  name: 'Fred Joe Smith',
  isMatchingProfileName: false,
};

export const shareableProfileVerifiedIdentities = [
  identityNotVerified,
  identityNameMatch,
  identityNameMismatch,
];

export const yearsOfExperience = {
  option: {
    id: '4',
    description: '2 years',
  },
  newToWorkforce: false,
};

export const approachability = {
  approachable: false,
};

export const scoreNoTips = {
  progress: 0,
  tips: [],
};

export const scoreSingleTip = {
  progress: 0.9,
  tips: [
    {
      action: {
        card: 'next-role',
        field: 'right-to-work',
        mode: null,
        item: null,
        __typename: 'ProfileScoreTipAction',
      },
      label: 'Add work rights',
      description: 'Let employers know you can work here.',
      score: 0.6,
      __typename: 'ProfileScoreTip',
    },
  ],
  __typename: 'ProfileScore',
};

export const scoreMultipleTips = {
  progress: 0.56,
  tips: [
    {
      action: {
        card: 'career-history',
        field: 'achievements',
        mode: null,
        item: '31437196-0146-421f-b73a-cf4d80ea59ac',
        __typename: 'ProfileScoreTipAction',
      },
      label: 'Update work history',
      description:
        'Show employers you have the skills and experience they need.',
      score: 0.95,
      __typename: 'ProfileScoreTip',
    },
    {
      action: {
        card: 'career-history',
        field: null,
        mode: null,
        item: null,
        __typename: 'ProfileScoreTipAction',
      },
      label: 'Add another role',
      description: 'It looks like you have 4 years experience. Is that right?',
      score: 0.8,
      __typename: 'ProfileScoreTip',
    },
    {
      action: {
        card: 'next-role',
        field: 'salary',
        mode: null,
        item: null,
        __typename: 'ProfileScoreTipAction',
      },
      label: 'Add salary',
      description:
        'Add a minimum salary to appear in more searches by employers.',
      score: 0.7,
      __typename: 'ProfileScoreTip',
    },
    {
      action: {
        card: 'profile-visibility',
        field: 'level',
        mode: null,
        item: null,
        __typename: 'ProfileScoreTipAction',
      },
      label: 'Set profile visibility',
      description: 'Be found by potential employers.',
      score: 0.7,
      __typename: 'ProfileScoreTip',
    },
    {
      action: {
        card: 'next-role',
        field: 'right-to-work',
        mode: null,
        item: null,
        __typename: 'ProfileScoreTipAction',
      },
      label: 'Add work rights',
      description: 'Let employers know you can work here.',
      score: 0.6,
      __typename: 'ProfileScoreTip',
    },
    {
      action: {
        card: 'next-role',
        field: 'classification',
        mode: null,
        item: null,
        __typename: 'ProfileScoreTipAction',
      },
      label: 'Add classification',
      description: 'Receive valuable industry insights from SEEK.',
      score: 0.3,
      __typename: 'ProfileScoreTip',
    },
    {
      action: {
        card: 'next-role',
        field: 'work-types',
        mode: null,
        item: null,
        __typename: 'ProfileScoreTipAction',
      },
      label: 'Add preferences',
      description: 'Add your work type preferences so jobs can come to you.',
      score: 0.2,
      __typename: 'ProfileScoreTip',
    },
  ],
  __typename: 'ProfileScore',
};

export const profileInsightsWithoutSearchImpressions = {
  searchImpressionCount: 0,
  viewCount: 17,
  activities: [],
};

export const profileInsightsWithoutActivities = {
  searchImpressionCount: 10,
  viewCount: 9,
  activities: [],
};

export const profileInsightsWithActivities = {
  searchImpressionCount: 4,
  viewCount: 17,
  activities: [
    {
      __typename: 'ProfileInsightsMessageSentActivity',
      advertiser: {
        id: '1',
        name: 'Woolworths',
      },
      date: '4d ago',
    },
    {
      __typename: 'ProfileInsightsResumeDownloadedActivity',
      advertiser: {
        id: '2',
        name: 'Coles',
      },
      date: '21 Oct 2023',
    },
    {
      __typename: 'ProfileInsightsResumeDownloadedActivity',
      advertiser: {
        id: '3',
        name: 'Bunnings',
      },
      date: '3 Oct 2023',
    },
    {
      __typename: 'ProfileInsightsJobSentActivity',
      advertiser: {
        id: '3',
        name: 'Bunnings',
      },
      date: '25 Sep 2023',
      job: {
        id: '12345',
        title: 'Software Engineer',
        url: 'https://www.seek.com.au/job/12345',
      },
    },
  ],
};

export const profileSuggestionsWithoutData = [];

export const profileSuggestionsWithSingleData = [
  {
    message: "Let's make sure employers can get in touch with you.",
    action: {
      label: 'Add personal details',
      context: {
        __typename: 'ProfileSuggestionPersonalDetailsActionContext',
        card: 'personal-details',
      },
      trackingCallToAction: 'add_personal_details',
    },
    trackingNudgeType: 'personal_details',
  },
];

export const profileSuggestionsWithData = [
  {
    message: "Let's make sure employers can get in touch with you.",
    action: {
      label: 'Add personal details',
      context: {
        __typename: 'ProfileSuggestionPersonalDetailsActionContext',
        card: 'personal-details',
      },
      trackingCallToAction: 'add_personal_details',
    },
    trackingNudgeType: 'personal_details',
  },
  {
    message: 'Highlight your experience to employers.',
    action: {
      label: 'Add most recent role',
      context: {
        __typename: 'ProfileSuggestionCareerHistoryActionContext',
        card: 'career-history',
      },
      trackingCallToAction: 'add_most_recent_role',
    },
    trackingNudgeType: 'recent_role',
  },
  {
    message: 'Let employers find and approach you for new job opportunities.',
    action: {
      label: 'Set profile visibility',
      context: {
        __typename: 'ProfileSuggestionProfileVisibilityActionContext',
        card: 'profile-visibility-v2',
      },
      trackingCallToAction: 'set_profile_visibility',
    },
    trackingNudgeType: 'profile_visibility',
  },
  {
    message:
      'You’re 50% more likely to be contacted by employers if you add a resumé.',
    action: {
      label: 'Add a resumé',
      context: {
        __typename: 'ProfileSuggestionResumeActionContext',
        card: 'resume',
      },
      trackingCallToAction: 'add_resume',
    },
    trackingNudgeType: 'resume',
  },
  {
    message:
      'Add a description so employers know what skills you could bring to their team.',
    action: {
      label: 'Complete work history',
      context: {
        __typename: 'ProfileSuggestionCareerHistoryActionContext',
        card: 'career-history',
      },
      trackingCallToAction: 'complete_work_history',
    },
    trackingNudgeType: 'career_history',
  },
  {
    message: 'Show employers you have the skills and experience they need.',
    action: {
      label: 'Add another role',
      context: {
        __typename: 'ProfileSuggestionCareerHistoryActionContext',
        card: 'career-history',
      },
      trackingCallToAction: 'add_another_role',
    },
    trackingNudgeType: 'another_role',
  },
  {
    message: 'Show employers that you’re qualified and ready for their role.',
    action: {
      label: 'Add education',
      context: {
        __typename: 'ProfileSuggestionEducationActionContext',
        card: 'education',
      },
      trackingCallToAction: 'add_education',
    },
    trackingNudgeType: 'education',
  },
  {
    message: 'Appear in more searches by adding a minimum salary.',
    action: {
      label: 'Add salary',
      context: {
        __typename: 'ProfileSuggestionSalaryActionContext',
        card: 'salary',
      },
      trackingCallToAction: 'add_salary',
    },
    trackingNudgeType: 'salary',
  },
  {
    message: 'Let employers know where you have the right to work.',
    action: {
      label: 'Add work rights',
      context: {
        __typename: 'ProfileSuggestionRightToWorkActionContext',
        card: 'right-to-work',
      },
      trackingCallToAction: 'add_work_rights',
    },
    trackingNudgeType: 'work_rights',
  },
  {
    message: 'Show employers you have the right skills for the role.',
    action: {
      label: 'Add 5 or more skills',
      context: {
        __typename: 'ProfileSuggestionSkillsActionContext',
        card: 'skills',
      },
      trackingCallToAction: 'add_5_or_more_skills',
    },
    trackingNudgeType: 'skills',
  },
  {
    message: 'Show employers you have the right credentials for the job.',
    action: {
      label: 'Add licence or certificate',
      context: {
        __typename: 'ProfileSuggestionLicencesActionContext',
        card: 'licences',
      },
      trackingCallToAction: 'add_licence_or_certificate',
    },
    trackingNudgeType: 'licence_or_certificate',
  },
  {
    message: 'Add languages to appeal to more companies and employers.',
    action: {
      label: 'Add language',
      context: {
        __typename: 'ProfileSuggestionLanguagesActionContext',
        card: 'languages',
      },
      trackingCallToAction: 'add_language',
    },
    trackingNudgeType: 'language',
  },
  {
    message: 'Add a summary of your career, achievements, and interests.',
    action: {
      label: 'Add summary',
      context: {
        __typename: 'ProfileSuggestionPersonalSummaryActionContext',
        card: 'summary',
      },
      trackingCallToAction: 'add_summary',
    },
    trackingNudgeType: 'summary',
  },
  {
    message: 'Add your availability so employers know how soon you can start.',
    action: {
      label: 'Add availability',
      context: {
        __typename: 'ProfileSuggestionAvailabilityActionContext',
        card: 'availability',
      },
      trackingCallToAction: 'add_availability',
    },
    trackingNudgeType: 'availability',
  },
  {
    message: 'Receive valuable insights about your industry.',
    action: {
      label: 'Add classification',
      context: {
        __typename: 'ProfileSuggestionClassificationActionContext',
        card: 'classification',
      },
      trackingCallToAction: 'add_classification',
    },
    trackingNudgeType: 'classification',
  },
  {
    message:
      'Full-time, part-time, contract – tell us what you’re looking for to get better recommendations.',
    action: {
      label: 'Add work preferences',
      context: {
        __typename: 'ProfileSuggestionWorkTypeActionContext',
        card: 'work-types',
      },
      trackingCallToAction: 'add_work_preference',
    },
    trackingNudgeType: 'work_preference',
  },
];

export const verificationsVerifiedSectionAllCredentials: Verified = [
  {
    label: 'Digital ID',
    credentials: [
      {
        label: 'Jamie Smith Doe',
        credentialType: 'identity',
        credentialInfo: [],
      },
    ],
  },
  {
    label: 'Workplace',
    credentials: [
      {
        label: 'Jayer Grocer',
        credentialType: 'workplace',
        credentialInfo: [{ name: 'Verified on', values: ['10 Jul 2023'] }],
      },
      {
        label: 'Woolworths',
        credentialType: 'workplace',
        credentialInfo: [{ name: 'Verified on', values: ['5 Jul 2023'] }],
      },
    ],
  },
  {
    label: 'Licences & certifications',
    credentials: [
      {
        label: 'Australian Manual Drivers Licence',
        credentialType: 'licence',
        credentialInfo: [
          { name: 'Country', values: ['Australia'] },
          { name: 'Type', values: ['Full'] },
          { name: 'State', values: ['SA'] },
          { name: 'Verified on', values: ['10 Jul 2024'] },
          { name: 'Name', values: ['Test name'] },
        ],
      },
      {
        label: 'SA Drivers Licence',
        credentialType: 'licence',
        credentialInfo: [
          { name: 'Country', values: ['Australia'] },
          { name: 'Verified on', values: ['10 Jul 2024'] },
          { name: 'Name', values: ['Jamie Doe'] },
        ],
      },
      {
        label: 'Australian MC Licence',
        credentialType: 'licence',
        credentialInfo: [
          { name: 'Country', values: ['Australia'] },
          { name: 'Class', values: ['MC'] },
          { name: 'Type', values: ['Full'] },
          { name: 'State', values: ['SA'] },
          { name: 'Verified on', values: ['10 Jul 2024'] },
          { name: 'Name', values: ['Test name'] },
        ],
      },
    ],
  },
];

export const verificationsVerifiableSectionAllCredentials: Verifiable = [
  {
    label: 'Digital ID',
    credentials: [
      {
        __typename: 'IdentityVerifiableCredential',
        label: 'Verify your name and identity',
        url: 'https://seekpass.co/au/credentials/digital-identity?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=digital-identity',
      },
    ],
    pendingCount: 0,
  },
  {
    label: 'Workplace',
    credentials: [
      {
        __typename: 'WorkplaceVerifiableCredential',
        label: 'Verify your workplace',
        url: 'https://seekpass.co/au/credentials/career-history?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=career-history',
      },
      {
        __typename: 'WorkplaceVerifiableCredential',
        label: 'Verify your role',
        url: 'https://seekpass.co/au/credentials/career-history?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=career-history',
      },
    ],
    pendingCount: 1,
  },
  {
    label: 'Licences & certifications',
    credentials: [
      {
        __typename: 'LicenceVerifiableCredential',
        label: "VIC Driver's Licence",
        url: 'https://seekpass.co/credentials/drivers-licence?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=drivers-licence',
        verificationMessage: 'Verify your Drivers Licence',
        trackingEntityName: 'Drivers Licence',
      },
    ],
    pendingCount: 0,
  },
];

export const verificationsVerifiableSectionWorkplaceOnly: Verifiable = [
  {
    label: 'Workplace',
    credentials: [
      {
        __typename: 'WorkplaceVerifiableCredential',
        label: 'Verify your workplace',
        url: 'https://seekpass.co/au/credentials/career-history?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=career-history',
      },
      {
        __typename: 'WorkplaceVerifiableCredential',
        label: 'Verify your role',
        url: 'https://seekpass.co/au/credentials/career-history?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=career-history',
      },
    ],
    pendingCount: 1,
  },
];

export const verificationsComplete: ProfileVerifications = {
  nudge: {
    __typename: 'VerifiableCredentialNudge2',
    credential: {
      __typename: 'WorkplaceVerifiableCredential',
      label: 'Verify your workplace',
      url: 'https://seekpass.co/au/credentials/career-history?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=career-history',
    },
  },
  verified: verificationsVerifiedSectionAllCredentials,
  verifiable: verificationsVerifiableSectionAllCredentials,
};

export const verificationsEmpty: ProfileVerifications = {
  nudge: null,
  verified: [],
  verifiable: [],
};

export const verificationsDigitalIdNudge = {
  ...verificationsComplete,
  nudge: {
    __typename: 'VerifiableCredentialNudge2',
    credential: {
      __typename: 'IdentityVerifiableCredential',
      label: 'Verify your name and identity',
      url: '',
    },
  },
};

export const verificationsEmptyVerified = {
  ...verificationsComplete,
  verified: [],
};

export const verificationsEmptyVerifiable = {
  ...verificationsComplete,
  verifiable: [],
};

export const verificationsOpenDrawerNudge = {
  ...verificationsComplete,
  nudge: {
    __typename: 'VerificationsOpenDetailsNudge',
    ref: '8328f5ae-0fae-4696-9d11-c5a872ca9faa',
  },
};

export const verificationsWorkplaceNudge = {
  ...verificationsComplete,
  nudge: {
    __typename: 'VerifiableCredentialNudge2',
    credential: {
      __typename: 'WorkplaceVerifiableCredential',
      label: 'Verify your workplace',
      url: 'https://seekpass.co/au/credentials/career-history?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=career-history',
    },
  },
};
